import clsx from 'clsx';
import React, { ComponentPropsWithRef } from 'react';

import { LinkButton } from './wrappers';

interface ILinkButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  weight?: 'thin' | 'regular' | 'medium' | 'bold';
  currentColor?: boolean; // Inherit color from parent
}

export default (props: ILinkButton & ComponentPropsWithRef<typeof LinkButton>) => {
  const { weight, currentColor, disabled } = props;
  const className = clsx(
    props.className,
    weight ? `weight-${weight}` : 'weight-medium',
    currentColor && 'current-color',
    disabled && 'disabled',
  );
  return <LinkButton {...props} className={className} />;
};
